/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![EyeIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACJ0lEQVR4nO1VO2tUURDeqCDa6A8wtYUSBUGtXMHXYs48LnLvzI2FpVgaX2CzvaCmEJFor9GAv0IrRRu1i4uSTkVF3SISZc492b2vfRjbDAxcON/5ZuabOXMbjQ37H2s2m1uIUgCWJ0jSQZJu8A6SPgYWF8fx5nWRQ6QtT8T6Z5gD63vHcvJfuCeAdC5H8AZRLwLoVBzHO8ztG1lm/VmGWwXSm3Z3JDmyPvDEpL+MuN1ubxoENnkskJfN35H5oUGA5HqWkfxwJMfGLRkxOQKs30NiV+vJo+QwkP62chEV82dEMoksi0YCoHvq7tsw+LusK8zpwcKhyYCkr0OZd8rkQPp5rSetVmvrQAVYbnkc6cuCtI7SM6GhH+I43lYon2UxPzVEcnRQAOfcdmBZ9ljUqE9C8jy7nJ6vZqVe256TdKw/ROd2TkfJ3poqLoRkn1UC2OHIAJx7A6Rfy3hLshKgL5EsW5kliZ4OfGgkC3msyQskHysSWUOA5VUY0duFABjvRpYv1ezlUxSd3VXAkt4Nib6ovB9EPbQ2pjZyxbJl0nYPsnzzTrJQJgcWCsFXmGcOlKXLQCTXAugnRHqiFlRjjtNmv1cyOww7ASz3g75dR3J52LYMq+JKb1Ww3BtrH4UHsxom5S2QXpqOkn02mpnP7LfgSPIut+xujEPeM6LklK3iUesaWZcQk+NjE5clABYHrI88EUnXb1nWJSB9SJSeXvcPZ8Mawf4CuYpoJprn1YoAAAAASUVORK5CYII=)
 */
export const EyeIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.56 11.77c.2-.1.44.02.44.23a4 4 0 1 1-4-4c.21 0 .33.25.23.44a2.5 2.5 0 0 0 3.32 3.32Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M22.89 11.7c.07.2.07.4 0 .6C22.27 13.9 19.1 21 12 21c-7.11 0-10.27-7.11-10.89-8.7a.83.83 0 0 1 0-.6C1.73 10.1 4.9 3 12 3c7.11 0 10.27 7.11 10.89 8.7Zm-4.5-3.62A15.11 15.11 0 0 1 20.85 12c-.38.88-1.18 2.47-2.46 3.92C16.87 17.62 14.8 19 12 19c-2.8 0-4.87-1.38-6.39-3.08A15.11 15.11 0 0 1 3.15 12c.38-.88 1.18-2.47 2.46-3.92C7.13 6.38 9.2 5 12 5c2.8 0 4.87 1.38 6.39 3.08Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
